<template>
    <div class="gobuy">

        <div class="head">
            <div class="back">
                <!-- <span class="iconfont" style="font-size: 20px;" @click="gotoBack">&#xe67f;</span> -->
                <img src="../../../assets/image/gobuy/b-t-lb.png" alt="">
            </div>
            <div class="center">
                <div class="h-id">
                    <ScrollingMessages v-if="messages" :message="messages" />
                </div>
            </div>
            <div class="r"></div>
        </div>

        <div class="flex">
            <div class="ll">
                <div class="gif">
                    <img src="https://file.goshop.shop/static/box/1.gif" v-if="opne_">
                    <img src="https://file.goshop.shop/static/box/2.gif" v-if="!opne_">
                </div>
            </div>

            <div class="r">
                <div class="title">
                    {{ $t('home.gobuy.title') }}
                </div>


                <div class="periods">
                    {{ $t('home.gobuy.periods') }}: {{ now_box_info ? now_box_info.num : 0 }}-{{ formatDate(currentDate) }}
                </div>

                <div class="countdown">
                    <div class="t">{{ $t('home.gobuy.freeze') }}:</div>
                    <Countdowm :deadline="now_box_info.close_start_time" @frozen="frozen" v-if="now_box_info" />
                </div>

                <div class="countdown">
                    <div class="t">{{ $t('home.gobuy.drawing') }}:</div>
                    <Countdowm :deadline="now_box_info.open_start_time" @frozen="drawing" v-if="now_box_info" />
                </div>

                <div class="pi ds-button-large" @click="getBuyBox_">
                    {{ isBuy ? $t('box.frozen') : $t('home.gobuy.buy') }}
                    <span style="font-size: 12px;" v-if="!isBuy">
                        ({{ $t('USDT') }} {{ buy_box_info ? buy_box_info.price : 0 }})
                    </span>
                </div>
            </div>
        </div>

        <div class="flex">
            <div class="ll">
                <div class="jackpot">
                    <div class="l">
                        <div class="t">{{ $t('home.gobuy.jackpot') }}</div>
                        <div class="p">${{ total }}</div>
                    </div>

                    <div class="r">
                        <img src="../../../assets/image/gobuy/chi.png" alt="">
                        <div class="chi" ref="chi" style="width: 40px; height: 80px;"></div>
                    </div>
                </div>
            </div>

            <div class="r">
                <div class="scroll-container list">
                    <div class="scroll-content ">
                        <div v-for="(item, index) in box_goods" :key="index" class="scroll-item item">
                            <div class="time">{{ item.date }}</div>
                            <div class="id">{{ item.member_name }}</div>
                            <div class="price">${{ item.price }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="side-navbar play">
            <div class="item " @click="p_pause" v-if="play">
                <img src="../../../assets/image/gobuy/pause.png" alt="">
            </div>
            <div class="item " @click="p_play" v-if="!play">
                <img src="../../../assets/image/gobuy/play.png" alt="">
            </div>
        </div>

        <div class="side-navbar">
            <div class="item qb" @click="openWallett">
                <div class="text">{{ $t('Purse') }}</div>
            </div>
            <div class="item hg" @click="openBoxList">
                <div class="text">{{ $t('Box') }}</div>
            </div>
        </div>

        <mt-popup v-model="boxShow" position="center" class="box-popup">
            <div class="box-cneter" v-if="boxData && boxData == 'ThankYouForParticipating'">
                <div class="tit title">{{ $t('GetAPrize') }}</div>
                <div class="info">
                    <div class="img">
                        <img src="../../../assets/image/gobuy/tks.png" alt="">
                    </div>
                    <div class="det">
                        <div class="name">{{ $t('ThankYouForParticipating') }}</div>
                        <div class="price" style="text-align: left;">$0.00</div>
                    </div>
                </div>
                <div class="btns">
                </div>
            </div>
            <div class="box-cneter" v-if="boxData && boxData != 'ThankYouForParticipating'">
                <div class="tit title">{{ $t('GetAPrize') }}</div>
                <div class="info">
                    <div class="img">
                        <img :src="boxData.goods_image" alt="">
                    </div>
                    <div class="det">
                        <div class="name">{{ boxData.goods_name }}</div>
                        <div class="price">${{ boxData.goods_price }}</div>
                    </div>
                </div>
                <div class="btns">
                    <div class="btn claim" @click="gotoView(boxData)">{{ $t('Claim') }}</div>
                    <div class="btn" @click="addBoxSave_(boxData)">{{ $t('Recycle') }}</div>
                </div>
            </div>
        </mt-popup>

        <mt-popup v-model="qbShow" position="right" class="hg-popup qb-popup" style="width: 30vw;height: 100vh;">
            <div class="hg-cneter qb-cneter">
                <div class="tit">{{ $t('My Wallet') }}</div>
                <div class="info">
                    <div class="l">
                        <div class="t">{{ $t('Available Balance') }}</div>
                        <div class="p">${{ available_predeposit }}</div>
                    </div>
                    <div class="r">
                        <div class="rec" @click="$router.push({ name: 'MemberRechargeList' })">{{ $t('Recharge') }}</div>
                        <div class="wit" @click="$router.push({ name: 'MemberWithdrawList' })">{{ $t('Withdraw') }}</div>
                    </div>
                </div>
                <div class="list1">
                    <div class="titlt">{{ $t('Fund Details') }}</div>
                    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                        <div class="list-wrapper" v-if="predeposit_list && predeposit_list.length">

                            <div class="item" v-for="(item, index) in predeposit_list" :key="index">
                                <div class="l">
                                    <div class="subtitle">{{ item.lg_desc }}</div>
                                    <div class="date">{{ item.lg_addtime_text }}</div>
                                </div>

                                <div class="r">
                                    <div class="title1" v-bind:class="item.lg_av_amount > 0 ? 'income' : 'expend'">
                                        {{ item.lg_av_amount }}$
                                    </div>
                                </div>
                            </div>
                        </div>
                        <empty-record v-else-if="predeposit_list && !predeposit_list.length"></empty-record>
                    </div>
                </div>
            </div>
        </mt-popup>

        <mt-popup v-model="hgShow" position="right" class="hg-popup" style="width: 30vw;height: 100vh;">
            <div class="hg-cneter">
                <div class="tit">{{ $t('MyBlindBox') }}</div>
                <div v-infinite-scroll="box_loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                    <div class="order-body" v-if="order_group_list && order_group_list.length">

                        <div class="list_" v-for="(item, index) in order_group_list" :key="index">
                            <router-link :to="'/member/blind_detail?order_id=' + item.id">
                                <div class="order-image" v-if="item.box_goods">
                                    <div style="color: #999;font-size: 14px;">
                                        {{ $t('home.gobuy.periods') }}: {{ item.num }}-{{ item.date }}
                                    </div>
                                    <div class="goods_info clearfix">
                                        <div class="img">
                                            <img v-bind:src="item.box_goods.goods_image" />
                                        </div>
                                        <div class="r">
                                            <div class="goods_name">
                                                {{ item.box_goods.goods_name }}
                                            </div>
                                            <div class="goods_price">
                                                <div class="price">${{ item.box_goods.goods_price }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-image" v-else>
                                    <div style="color: #999;font-size: 14px;">
                                        {{ $t('home.gobuy.periods') }}: {{ item.num }}-{{ item.date }}
                                    </div>
                                    <div class="goods_info clearfix">
                                        <div class="img">
                                            <img v-bind:src="item.img" />
                                        </div>
                                        <div class="r">
                                            <div class="goods_name" v-if="item.box_goods_id">
                                                {{ item.title }}
                                            </div>
                                            <div class="goods_name" v-else>
                                                {{ $t('box.frozen') }}
                                            </div>
                                            <div class="goods_price" v-if="item.box_goods_id">
                                                <div class="price">${{ item.price }}</div>
                                            </div>
                                            <div class="goods_price" v-else>
                                                <div class="price">-$1.00</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </router-link>

                            <div class="order-list-opratio" v-if="item.box_goods_id">
                                <router-link :to="'/member/pick_up_goods?order_id=' + item.id">
                                    <button v-if="item.status == 1" class="line_red">{{ $t('Claim') }}</button>
                                </router-link>
                                <button v-if="item.status == 1" v-on:click="addBoxSave_(item)" class="line_red">
                                    {{ $t('Recycle') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <empty-record v-else-if="order_group_list && !order_group_list.length"></empty-record>
                </div>
            </div>
        </mt-popup>

        <audio id="myAudio" ref="backgroundAudio" src="../../../assets/image/gobuy/44s.mp3" muted autoplay loop
            style="display: none;" v-if="opne_"></audio>
        <audio id="myAudio" ref="backgroundAudio" src="../../../assets/image/gobuy/15s.mp3" muted autoplay loop
            style="display: none;" v-else></audio>
        <button id="kaiqi" onclick="document.getElementById('myAudio').muted = false;" style="display: none;">播放</button>
        <div class="bottom"></div>
    </div>
</template>
  
<script>
import * as echarts from 'echarts';
import 'echarts-liquidfill';

import store from '../../../store'

import lottie from './lottie.vue';
import * as animationData from './data1.json';
import ScrollingMessages from './ScrollingMessages.vue';

import Countdowm from '../common/Countdown.vue'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { getMemberIndex } from '../../../api/member'
import { getBoxList, addBoxSave } from '../../../api/memberOrder'
import { getPredepositList } from '../../../api/memberPredeposit'
import { getBoxListGobuy, getBoxInfo, getBuyBox, getBoxLastInfo, getBoxNewInfo } from '../../../api/gobuy'

var ws

export default {
    components: {
        lottie,
        Countdowm,
        EmptyRecord,
        ScrollingMessages
    },
    data() {
        return {
            buy_box_info: null, //购买当前盲盒的数据
            currentDate: new Date(), //处理当前的时间格式
            total: null, //奖池合计
            first: null, //头奖数据 - 改为用户自身name
            percentage: null, //奖池echarts数据
            box_goods: null, //底部滚动数据
            now_box_info: null, //页面盲盒详情数据
            frozen_: true, //是否可以购买盲盒，封盘倒计时结束不可购买
            isBuy: false, //是否已经购买盲盒，购买之后状态文字改变
            opne_: true, //是否展示开盒动画，封盘倒计时结束开启
            boxShow: false, //是否显示盲盒奖品弹出层
            boxData: null,  //盲盒奖品数据
            qbShow: false, //是否显示钱包弹出层
            hgShow: false, //是否显示盲盒弹出层
            timer: null,  //奖池请求
            play: true, // 初始状态设不为静音
            audio: null, // 音频对象
            // box list
            params: { 'page': 0, 'per_page': 10 },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            box_params: { 'page': 0, 'per_page': 10 },
            box_loading: false, // 是否加载更多
            box_isMore: true, // 是否有更多
            stateType: null, // 盲盒状态类型指定为全部
            order_group_list: false, //box list
            available_predeposit: 0.00, //可用余额
            predeposit_list: false, //余额明细
            messages: '',
            userInfo: null,

            // ws
            timeOut: false,
            lockReconnect: false,
            canReconnect: true,
            socket_connect: 0,

            defaultOptions: { animationData: animationData.default },
            animationSpeed: 1,
        }
    },
    computed: {
    },
    created() {
        this.utils.preloadImages(['https://file.goshop.shop/static/box/1.gif', 'https://file.goshop.shop/static/box/2.gif'])

        this.getBoxList()
        this.getBoxInfo()

        this.updataQbMh()

        this.createWebSocket()
    },
    mounted() {
        this.chartInstance = echarts.init(this.$refs.chi); // 初始化 ECharts 实例

        // this.startCountDown();
        // document.addEventListener('visibilitychange', this.handleVisibilityChange);

        this.audio = document.getElementById('myAudio');
        this.toggleMute()

        this.audio.volume = 0.2
        this.audio.addEventListener('timeupdate', () => {
            if (this.opne_) {
                // 检查当前时间是否达到结束时间
                if (this.audio.currentTime > 40) {
                    // console.log('当前播放时间:', this.audio.currentTime);
                    // this.audio.pause();
                    this.audio.currentTime = 0; // 重置到0秒
                    this.audio.play(); // 重新播放
                }
            }
        });

    },
    methods: {
        handleAnimation: function (anim) {
            this.anim = anim;
        },

        createWebSocket() {
            let ws_url = env.WS_URL
            try {
                ws = new WebSocket(ws_url)
                this.init()
            } catch (e) {
                this.reconnect()
            }
        },
        init() {
            ws.onopen = this.wsOpen
            ws.onmessage = this.wsMessage
            ws.onclose = this.wsClose
            ws.onerror = this.wsError
        },
        wsOpen() {
            //请求参数
            var param = {
                type: "login",
                activity_type: "box",
                key: store.state.member.token,
                member_id:store.state.member.info.member_id
            };
            // 使用 send() 方法发送数据
            ws.send(JSON.stringify(param));

            this.socket_connect = 1
            // 心跳检测重置
            heartCheck.start()
        },
        wsMessage(res) {
            let that = this
            let res_ = JSON.parse(res.data)

            // console.log(res_, this.isObjectWithUid(res_.data));
            if (this.isObjectWithUid(res_.data)) {
                let data = res_.data
                if (data.hasOwnProperty('uid')) {
                    this.utils.save('WSUID', res_.data.uid)
                } else if (data.hasOwnProperty('percentage')) {

                    if (res_.code == 10000) {
                        if (that.total != res_.data.total) {
                            that.total = Math.floor(res_.data.total)
                        }

                        if (that.percentage != res_.data.percentage) {
                            that.percentage = res_.data.percentage
                            // 调用方法生成水球图
                            that.renderLiquidFillChart();
                        }
                    } else if (res_.code == 10001) {
                        that.reconnect()
                    }

                }

            }
            heartCheck.start()
        },
        wsClose(res) {
            this.socket_connect = 0
            if (res.reason) {
                console.log('聊天系统连接断开：' + res.reason)
            }
            if (this.canReconnect) {
                this.reconnect()
            }

        },
        wsError(res) {
            // Toast(res.errMsg)
            this.reconnect()
        },
        reconnect() {
            if (this.lockReconnect) {
                return
            };
            this.lockReconnect = true
            // 没连接上会一直重连，设置延迟避免请求过多
            this.timeOut && clearTimeout(this.timeOut)
            var _this = this
            this.timeOut = setTimeout(function () {
                _this.createWebSocket()
                _this.lockReconnect = false
            }, 4000)
        },
        isObjectWithUid(data) {
            // 检查 data 是否是对象并且不是 null
            if (typeof data === 'object' && data !== null) {
                // 检查对象是否具有 uid 属性
                return true
            }
            return false;
        },

        gotoBack() {
            this.$router.go(-1)
            this.stopPolling()
        },
        // 获取盲盒信息
        getBoxInfo() {
            getBoxInfo().then(res => {
                if (res.code == 10000) {
                    this.total = Math.floor(res.result.total)
                    this.first = res.result.first
                    this.box_goods = res.result.line
                    this.percentage = res.result.percentage
                    this.now_box_info = res.result.now_box_info
                    this.isBuy = res.result.has_box == 1 ? true : false

                    this.messages = `${this.$t('congratulations')} ${this.maskId(this.first.member.member_name)} ${this.$t('Obtain')} ${this.first.goods.goods_name} $${this.first.price}`

                    // 调用方法生成水球图
                    // this.renderLiquidFillChart();
                }
            }).catch(function (error) {
                console.log(error);
                //Toast(error.msg)
            })
        },
        // 获取当前盲盒信息
        getBoxList() {
            getBoxListGobuy().then(res => {
                if (res.code == 10000) {
                    this.buy_box_info = res.result.data[0]
                }
            }).catch(function (error) {
                console.log(error);
                //Toast(error.msg)
            })
        },
        // 购买盲盒
        getBuyBox_() {
            let that = this
            that.getBoxList()
            that.getBoxInfo()
            if (!that.frozen_) return

            if (!that.isBuy) {

                MessageBox({
                    title: that.$t('MessageBox.Tips'),
                    message: that.$t('MessageBox.buy.box'),
                    confirmButtonText: that.$t('MessageBox.Confirm'),
                    cancelButtonText: that.$t('MessageBox.Cancel'),
                    showCancelButton: true
                }).then(action => {
                    if (action == 'confirm') {
                        getBuyBox({ num: 1, box_id: this.buy_box_info.id }).then(res => {
                            if (res.code == 10000 || res.status) {
                                Toast(that.$t('box.succeeds'))
                            } else if (res.code == 10043) {

                                Toast(res.msg)
                                setTimeout(() => {
                                    that.$router.push({ name: 'MemberRechargeList' })
                                }, 1000);

                            } else if (res.status === false) {
                                // Toast(that.$t('box.issue'))
                                Toast(res.msg)
                            } else {
                                // Toast('Do not operate frequently')
                                Toast(res.msg)
                            }
                            that.getBoxList()
                            that.getBoxInfo()

                            that.updataQbMh()
                        }).catch(function (error) {
                            console.log(error);
                            //Toast(error.msg)
                        })
                    }
                })

            } else {
                Toast(that.$t('box.frozen'))
            }
        },
        // 折现
        addBoxSave_(orderInfo) {
            let that = this
            that.boxShow = false
            addBoxSave(orderInfo.box_goods.my_box_id || orderInfo.id).then(res => {
                if (res.code == 10000) {
                    Toast(res.message)
                } else {
                    Toast(res.message)
                }

                that.updataQbMh()
            }).catch(function (error) {
                Toast(that.$t('err'))
            })
        },
        // 处理 时间 dd-mm-yy
        formatDate(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1; // 月份是从0开始的，所以需要加1
            var year = date.getFullYear();

            // 如果日或月是一位数，则前面补零
            day = day < 10 ? '0' + day : day;
            month = month < 10 ? '0' + month : month;

            return day + '-' + month + '-' + year;
        },
        // 处理id
        maskId(id) {
            id = String(id)
            // 获取第一个字符
            var firstChar = id.substring(0, 2);
            // 获取最后一个字符
            var lastChar = id.substring(id.length - 2);
            // 返回新的字符串
            return firstChar + '***' + lastChar;
        },
        // frozen
        frozen() {
            this.frozen_ = false

            if (!this.isBuy) return

            this.opne_ = false
            this.stopPolling()
            this.toggleMute()
        },
        /* drawing 
        code: 10045 - 没有购买商品
        */
        drawing() {
            let that = this

            if (!that.isBuy) {
                that.frozen_ = true
                that.now_box_info = null

                that.getBoxList()
                that.getBoxInfo()

                return
            }

            that.boxShow = false
            that.qbShow = false
            that.hgShow = false

            Indicator.open('Loading...');
            that.opne_ = true
            that.getBoxList()

            setTimeout(() => {
                getBoxLastInfo().then(res => {
                    that.now_box_info = null
                    if (res.code == 10000) {
                        that.boxData = res.result[0]
                        that.boxShow = true
                    }
                    if (res.code == 10044) {
                        that.boxData = 'ThankYouForParticipating'
                        that.boxShow = true
                    }

                    that.getBoxInfo()

                    this.updataQbMh()

                    that.frozen_ = true
                    // this.startCountDown();
                    that.toggleMute()

                    Indicator.close();
                }).catch(function (error) {
                    console.log(error);
                    //Toast(error.msg)
                })
            }, 3000);

        },
        // 打开钱包弹窗
        openWallett() {
            this.qbShow = true
            // 重置分页
            this.loading = false
            this.params.page = 1
            this.isMore = true
        },
        // 更新钱包、盲盒列表
        updataQbMh() {
            // 初始化 购买 开出 折现
            this.getMemberIndex_(true)
            this.getOrderList(true)
        },
        // 获取钱包数据
        getMemberIndex_() {
            getMemberIndex().then(
                response => {
                    if (response && response.result.member_info) {
                        this.userInfo = response.result.member_info

                        this.available_predeposit = response.result.member_info.available_predeposit
                        this.getPredepositList_(true)
                    }
                },
                error => { }
            )
        },
        // 钱包明细列表
        getPredepositList_(ifReplace) {
            if (ifReplace) {
                this.loading = false
                this.params.page = 1
                this.isMore = true
            }

            getPredepositList(this.params).then(res => {
                if (res.result.hasmore) {
                    this.isMore = true
                } else {
                    this.isMore = false
                }

                let temp = res.result.list
                if (temp) {
                    if (ifReplace || !this.predeposit_list) {
                        this.predeposit_list = temp
                    } else {
                        this.predeposit_list = this.predeposit_list.concat(temp)
                    }
                }
            }).catch(function (error) {
                Toast(error.message)
            })
        },
        // 打开盲盒列表弹窗
        openBoxList() {
            this.hgShow = true
            // 重置分页
            this.box_loading = false
            this.box_params.page = 1
            this.box_isMore = true
        },
        // 获取盲盒列表
        getOrderList(ifReplace) {
            if (ifReplace) {
                this.box_loading = false
                this.box_params.page = 1
                this.box_isMore = true
            }

            getBoxList(this.box_params, this.stateType, '', '', this.stateType).then(res => {
                if (res.result.current_page !== res.result.last_page) {
                    this.box_isMore = true
                } else {
                    this.box_isMore = false
                }

                // let tOrderGroup = res.result.order_group_list
                let tOrderGroup = res.result.data

                if (tOrderGroup) {
                    if (ifReplace || !this.order_group_list) {
                        this.order_group_list = tOrderGroup
                    } else {
                        this.order_group_list = this.order_group_list.concat(tOrderGroup)
                    }
                }
            }).catch(function (error) {
                Toast(error.message)
            })
        },
        // 分页
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getPredepositList_(false)
            }
        },
        box_loadMore() {
            this.box_loading = true
            this.box_params.page = ++this.box_params.page
            if (this.box_isMore) {
                this.box_loading = false
                this.getOrderList(false)
            }
        },

        // Echarts
        renderLiquidFillChart() {
            let that = this
            let num = Number(that.percentage)
            try {

                // 使用 ECharts 生成水球图
                this.chartInstance.setOption({
                    series: [
                        {
                            type: 'liquidFill',
                            data: [num + 0.04, num + 0.02, num, num - 0.02, num - 0.04],
                            radius: '50%',
                            shape: 'container',
                            center: ['50%', '75%'],
                            color: ['#FEC088', '#FEC077', '#FEC066'],
                            backgroundStyle: {
                                color: 'transparent',
                                // borderColor: '#156ACF',
                                // borderWidth: 1,
                                // shadowColor: 'rgba(0, 0, 0, 0.4)',
                                // shadowBlur: 20
                            },
                            outline: {
                                show: false
                            },
                            label: {
                                show: false
                            },
                            waveAnimation: true,                   // 是否开启水波动画效果
                            amplitude: 2,                          // 水波的振幅大小

                        }]
                });

            } catch (error) {
                // console.log(error);
            }
        },
        addNum(data) {
            let num = 0
            for (let i = 0; i < data.length; i++) {
                num += Number(data[i].goods_price)
            }
            return num
        },
        goAccount() {
            this.$router.push({ name: 'MemberAccount' })
        },
        goBox() {
            this.$router.push({
                name: 'BlindBoxList'
            })
        },
        gotoView(orderInfo) {
            this.boxShow = false
            this.$router.push({ name: 'PickUpGoods', query: { order_id: orderInfo.box_goods.my_box_id } })
        },
        startCountDown() {
            let that = this

            getBoxNewInfo().then(res => {
                if (res.code == 1000) {
                    if (that.total != res.result.total) {
                        that.total = Math.floor(res.result.total)
                    }
                    if (that.percentage != res.result.percentage) {
                        that.percentage = res.result.percentage
                        // 调用方法生成水球图
                        // that.renderLiquidFillChart();
                    }
                }
            }).catch(function (error) {
                // Toast(error)
                that.timer = null
                return false
            }).finally(() => {
                // 在请求完成后再次设置 setTimeout
                // that.timer = setTimeout(that.startCountDown, 3000);
            });
        },
        stopPolling() {
            clearTimeout(this.timer);
            this.timer = null;
        },
        handleVisibilityChange() {
            if (document.visibilityState == "visible") {
                this.getBoxList()
                this.getBoxInfo()
                this.updataQbMh()

                this.stopPolling()
                // this.startCountDown();
                // console.log('浏览器进入用户视野中')
            } else {
                this.stopPolling()
            }
        },
        destroyChart() {
            if (this.chartInstance) {
                this.chartInstance.dispose();
                this.chartInstance = null;
            }
        },
        playAudio() {
            this.$refs.backgroundAudio.play();
        },
        pauseAudio() {
            this.$refs.backgroundAudio.pause();
        },
        toggleMute() {
            if (this.play) {
                const kq = document.getElementById('kaiqi');
                kq.click()
            }
        },

        p_pause() {
            this.play = false
            this.audio.muted = true
            this.audio.pause()
        },
        p_play() {
            this.play = true
            this.audio.muted = false
            this.audio.play()
        },

    },
    beforeDestroy() {
        this.audio.pause();
        this.destroyChart();
        this.stopPolling()
        // document.removeEventListener('visibilitychange', this.handleVisibilityChange);

        this.canReconnect = false
        this.socket_connect = 0
        heartCheck.stop()
    }
}

// 心跳检测
var heartCheck = {
    timeout: 10000,
    timeoutObj: null,
    start: function () {
        var self = this
        this.timeoutObj && clearInterval(this.timeoutObj)
        this.timeoutObj = setInterval(function () {
            // 这里发送一个心跳，后端收到后，返回一个心跳消息，
            // ws.send('123456789')
        }, this.timeout)
    },
    stop: function () {
        this.timeoutObj && clearInterval(this.timeoutObj)
    }
}
</script>
  
<style lang='scss' scoped>
.flex {
    display: flex;
    justify-content: center;
    align-items: center;

    .ll {
        width: 495px;
        display: flex;
        justify-content: flex-end;
    }
}

.lottie {
    width: 1000px;
    height: 700px;
    border: 1px solid #ff0000;
    position: fixed;
    top: 0px;
    right: 50px;
}

[v-cloak] {
    display: none;
}

.gobuy {
    overflow: hidden;
    width: 100%;
    background: url('../../../assets/image/gobuy/box.png') no-repeat;
    background-size: 100% 100%;
    position: relative;

    .head {
        width: 382px;
        height: 63px;
        background: url('../../../assets/image/gobuy/b-top.png') no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 19px;
        color: #A62C22;
        font-weight: 600;
        box-sizing: border-box;
        margin: 20px auto;
        padding: 22px;

        .back {
            width: 22px;
            height: 22px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .h-id {
            width: 10rem;
            overflow: hidden;
            margin-right: 1.6rem;
        }

        .center {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .title {
        font-weight: 600;
        font-size: 38px;
        color: #FFFFFF;
        text-align: center;
        text-shadow:
            5px 5px 10px #b3483e,
            4px 4px 5px rgba(179, 72, 62, 0.5);
    }

    .gif {
        width: 446px;
        height: 309px;
        margin: 18px auto;
        position: relative;

        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(1.5);
            width: 16rem;
            height: 9rem;
        }
    }

    .periods {
        font-weight: 600;
        text-align: center;
        font-size: 16px;
        color: #A62C22;
        margin: 16px 0;
    }

    .countdown {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px 0;
        font-size: 12px;
        color: #000000;
        height: 1.7rem;

        .t {
            // width: 60px;
            text-align: right;
        }

        .dot {
            width: 30px;
            height: 30px;
            margin: 0 5px;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            line-height: 30px;
            border-radius: 999px;
            border: 2px solid #A62C22;
        }
    }

    .pi {
        color: #fff;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #E7010C;
        border-radius: 6px 6px 6px 6px;
        margin-left: 20px;
    }

    .jackpot {
        width: 284px;
        margin: 20px;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #FFFFFF;
        background-image: linear-gradient(to right, #fbb990, #f56a11);

        .l {
            font-weight: 600;
            font-size: 23px;
            text-align: center;
            color: #FFFFFF;
        }

        .r {
            width: 118px;
            height: 118px;
            position: relative;

            img {
                width: 100%;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }

            .chi {
                position: absolute;
                top: 43%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 2;
            }
        }
    }

    .list {
        margin: 30px 0;
        padding: 12px;
        font-size: 15px;
        color: #A62C22;
        background: linear-gradient(271deg, rgba(255, 255, 255, 0.12) 0%, #FFFFFF 45%, rgba(255, 255, 255, 0) 100%);
        box-sizing: border-box;

        .item {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .side-navbar {
        position: absolute;
        top: 20%;
        right: 1%;
        z-index: 99;

        .item {
            cursor: pointer;
            width: 43px;
            height: 53px;
            margin-bottom: 16px;
            position: relative;

            .text {
                text-align: center;
                font-weight: 600;
                font-size: 12px;
                color: #A62C22;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                white-space: nowrap;
            }
        }

        .qb {
            background: url('../../../assets/image/gobuy/qb.png') no-repeat;
            background-size: 100% 100%;
        }

        .hg {
            background: url('../../../assets/image/gobuy/hg.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .play {
        width: 12px;
        left: 1%;

        .item {
            width: 12px;
            height: 12px;
            padding: 10px;
        }

        img {
            width: 12px;
            height: 12px;
        }
    }

    .box-popup {
        width: 11.4rem;
        height: 14rem;
        margin: 0 auto;
        padding: 20px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        background-image: url('../../../assets/image/gobuy/mhtcc.png');
        background-repeat: no-repeat;
        background-size: 100%;
        background-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;

        .box-cneter {
            padding-left: 10px;

            .info {
                margin: 150px 0 20px;
                display: flex;
                justify-content: center;
                align-items: flex-start;

                .det {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    color: #A62C22;

                    .name {
                        width: 3.5rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }

        .tit {
            text-align: center;
            font-size: 42px;
            margin-top: -80px;
        }

        .price {
            text-align: right;
            margin: 10px 0;
        }

        .img {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;

            img {
                width: 60px;
                height: 60px;
                border-radius: 10px;
                margin-right: 10px;
            }
        }

        .btns {
            display: flex;
            justify-content: space-around;

            .btn {
                cursor: pointer;
                width: 45%;
                // height: 40px;
                text-align: center;
                // line-height: 40px;
                text-align: center;
                border-radius: 30px;
                box-sizing: border-box;
                padding: 10px 0;
                border: 1px solid #FB2933;
                font-size: 15px;
                background: #FB2933;
                color: #fff;
            }

            .claim {
                background: #FFFFFF;
                color: #FB2933;
            }
        }
    }
}

img {
    width: 100%;
    display: block;
    margin: 0 auto;
}

.hg-popup {
    box-sizing: border-box;
    padding: 20px;
    background: #F9F9F9;
    border-radius: 10px 0px 0px 10px;

    .hg-cneter {
        .tit {
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            color: #000000;
        }

        .info {
            margin: 22px 5px;
            padding: 28px 16px;
            background: #A62C22;
            border-radius: 5px 5px 5px 5px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: column;

            .l {
                margin-bottom: 12px;

                .t {
                    font-size: 14px;
                    color: #D39691;
                }

                .p {
                    font-size: 33px;
                    color: #FFFFFF;
                    font-weight: 600;
                }
            }

            .r {
                display: flex;
                align-items: center;

                div {
                    background: #B8564E;
                    border-radius: 5px;
                    margin: 0 6px;
                    padding: 5px 16px;
                    font-size: 14px;
                    color: #FFFFFF;
                }
            }
        }
    }
}

.order-body {
    position: relative;
    padding-top: 0.3rem;
    background: #F9F9F9;
    box-sizing: border-box;

    .list_ {
        width: 100%;
        margin-top: 0.5rem;
        background: #fff;
        border-radius: 10px;
        padding: 15px;
        box-sizing: border-box;

        .tips-body {
            height: 2.2rem;
            background: rgb(255, 255, 255);
            display: flex;
            justify-content: space-between;
            padding: 0 0.75rem 0 0.5rem;

            .tips {
                font-size: $subFontSize;
                color: #333;
                line-height: 2.2rem;
            }

            .statusTips {
                color: $primaryColor;
            }

            img {
                width: 3.8rem;
                height: 3rem;
            }
        }

        .order-image {
            width: 100%;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;

            .goods_info {
                background: #fff;
                height: 4rem;
                display: flex;
                align-items: center;
                padding-right: $pageSpace;

                .img {
                    width: 3rem;
                    margin: 0 .3rem;

                    img {
                        width: 3rem;
                        border-radius: 1px;
                    }
                }

                .goods_name {
                    white-space: normal;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    width: 10rem;
                    font-size: .7rem;
                    color: #333;
                }

                .goods_price {
                    margin-left: auto;
                    padding-right: .75rem;
                    margin: .5rem 0;
                    text-align: left;

                    .price {
                        font-size: $subFontSize;
                        color: rgba(78, 84, 93, 1);
                    }

                    .num {
                        font-size: .6rem;
                        color: #999;
                        padding-top: .3rem;
                    }
                }
            }
        }

        .multiple {
            .imagebox {
                width: 100%;
                overflow-x: auto;
                white-space: nowrap;

                img {
                    width: 3rem;
                    height: 3rem;
                    margin: .85rem .3rem .5rem;
                    display: inline-block;
                }
            }
        }

        .order_amount {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            line-height: 2.2rem;
            height: 2.2rem;
            background-color: #fff;
            padding: 0 0.75rem 0 0;
            border-bottom: 1px solid #e8eaed;
            box-sizing: border-box;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .order_amount_icon {
                font-size: $subFontSize;
                color: $primaryColor;
            }

            i {
                font-size: $h2;
                color: $primaryColor;
                padding-left: 0.15rem;
                font-style: normal;

                &.freight {
                    color: #333;
                    font-size: $fontSize;
                }
            }
        }
    }

    .loading-wrapper {
        text-align: center;

        p {
            color: #c3c3c3;
            font-size: $fontSize;
            margin: 0.5rem auto;
        }
    }
}

.qb-popup {
    background-color: #fff;

    .qb-cneter {
        .r {
            div {
                cursor: pointer;
            }
        }

        .list1 {
            .titlt {
                font-size: 18px;
                font-weight: 600;
                color: #000000;
                margin-bottom: 22px;
            }

            .list-wrapper {
                padding: 0 20px;
                border-radius: 20px;
                border: 1px solid #aeaeae;

                .item {
                    margin: 11px 0;
                    padding: 20px 0;
                }
            }
        }
    }
}

.list-wrapper {
    .item {
        display: flex;
        position: relative;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }

    .title1 {
        font-size: $h1;
        margin-left: 0.7rem;
        margin-top: 0.7rem;
    }

    .income {
        color: $primaryColor;
    }

    .expend {
        color: #333;
    }

    .subtitle {
        font-size: $fontSize;
        color: #666;
        margin-bottom: 0.5rem;
    }

    .date {
        color: #666;
        font-size: $subFontSize;
    }
}

.order-list-opratio {
    display: flex;
    justify-content: flex-end;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.1rem;
}

.order-list-opratio button {
    cursor: pointer;
    width: 4.5rem;
    height: 1.5rem;
    font-size: $subFontSize;
    border-radius: 0.4rem;
    margin: 0.35rem 0.75rem 0.35rem 0;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .05);
}

.order-list-opratio .line_red {
    background-color: #fff;
    color: #A62C22;
    border: 1px solid #A62C22;
    box-shadow: 0 3px 6px 0 rgba(242, 39, 12, .1);
}

.bottom {
    height: 1px;
}

.scroll-container {
    /* 设置高度和溢出处理 */
    height: 100px;
    /* 你可以根据需要设置 */
    overflow: hidden;
    position: relative;
}

.scroll-content {
    display: flex;
    flex-direction: column;
    animation: scroll 100s linear infinite;
    /* 动画滚动 */
    will-change: transform;
    /* 提示浏览器进行性能优化 */
    backface-visibility: hidden;
    /* 分层渲染 */
    perspective: 1000px;
    /* 分层渲染 */
}

.scroll-item {
    text-align: left;
    height: 30px;
    /* 每个项目的高度 */
    line-height: 30px;
    /* 垂直居中 */

    .time {
        width: 7.5rem;
        white-space: nowrap;
    }

    .id {
        width: 3rem;
    }

    .price {
        min-width: 3rem;
    }
}

/* 添加关键帧动画 */
@keyframes scroll {
    from {
        transform: translate3d(0, 0, 0);
        /* 从起始位置开始 */
    }

    to {
        transform: translate3d(0, -50%, 0);
        /* 向上移动一半的位置 */
    }
}
</style>
  